"use strict";

exports.__esModule = true;
exports.validateResponses = exports.validateQuestions = exports.parseQuestions = exports.checkResponseIsValid = void 0;

var _constants = require("../../utils/constants");

var _conditions = require("./conditions");

var checkResponseIsValid = function checkResponseIsValid(response, type, isRequired, props) {
  if (!isRequired) return true;
  if (response === null) return false;

  switch (type) {
    case _constants.CHOICE_TYPE:
    case _constants.FILE_UPLOAD_TYPE:
      return response.length !== 0;

    case _constants.ADDRESS_CHECKER_TYPE:
    case _constants.RATING_TYPE:
    case _constants.TEXT_ANSWER_TYPE:
      return (response == null ? void 0 : response.trim()) !== '';

    case _constants.NUMERIC_ANSWER_TYPE:
      return response.trim() !== '' && response > props.min && response < props.max && props.pattern.test(response);

    case _constants.SELECT_TYPE:
      return response.some(function (s) {
        return s !== '';
      });

    default:
      return true;
  }
};

exports.checkResponseIsValid = checkResponseIsValid;

var validateResponses = function validateResponses(responses, questions) {
  var pairings = responses.map(function (x) {
    return {
      questionId: x.questionId,
      response: x.value,
      isValid: checkResponseIsValid(x.value, questions.filter(function (y) {
        return y.id === x.questionId;
      })[0].component.type, questions.filter(function (y) {
        return y.id === x.questionId;
      })[0].component.props.required, questions.filter(function (y) {
        return y.id === x.questionId;
      })[0].component.props) || !(0, _conditions.resolveQuestionConditions)(responses, questions.filter(function (q) {
        return q.id === x.questionId;
      })[0].conditions)
    };
  });
  var invalidResponses = pairings.filter(function (x) {
    return !x.isValid;
  });
  return {
    isValid: invalidResponses.length === 0,
    invalidResponses: invalidResponses
  };
};

exports.validateResponses = validateResponses;

var validateQuestions = function validateQuestions(questionInput) {
  var errors = {};

  if (!questionInput.title) {
    errors = Object.assign({}, errors, {
      title: _constants.QUESTION_BUILDER_VALIDATION_TITLE_NO_VALUE
    });
  }

  if (questionInput.component.type === _constants.CHOICE_TYPE) {
    var choices = questionInput.component.props.choices;

    if (!choices.length) {
      errors = Object.assign({}, errors, {
        choices: {
          error: _constants.QUESTION_BUILDER_VALIDATION_CHOICE_NONE
        }
      });
    } else {
      var choicesWithNoValue = choices.reduce(function (error, choice) {
        return !choice.value ? [].concat(error, [choice.id]) : error;
      }, []);

      if (choicesWithNoValue && choicesWithNoValue.length) {
        errors = Object.assign({}, errors, {
          choices: {
            error: _constants.QUESTION_BUILDER_VALIDATION_CHOICE_NO_VALUE,
            choices: choicesWithNoValue
          }
        });
      }
    }
  }

  return errors;
};

exports.validateQuestions = validateQuestions;

var parseQuestions = function parseQuestions(questions) {
  return questions.filter(function (x) {
    return x.state !== 'new';
  }).map(function (q) {
    return {
      id: q.id,
      position: q.position,
      title: q.title,
      description: q.description,
      conditions: q.conditions,
      component: q.component
    };
  }).sort(function (a, b) {
    return a.position - b.position;
  });
};

exports.parseQuestions = parseQuestions;